import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { app } from "../../Frame/App";
import { TextComponent } from "../../Components/TextComponent";
import { MsoTable } from "./MsoTable";
import { ListItem } from "../../Model/ListItem";

export class ColumnDouble extends ColumnBase {

    getCellClass(): string {
        if (this.isEditable) {
            return super.getCellClass() + " mt-textedit";
        }
        else {
            return super.getCellClass();
        }
    }

    public getContent(row: any): HTMLElement {
        if (this.isEditable) {
            let textComp = new TextComponent({
                field: this.field,
                model: row,
                createFormGroup: false,
                restrictTo: this.decimals == 0 ? "integer" : "decimal",
                decimalPlaces: this.decimals,
                changeEvent: () => {
                    if (this.table.props.onModelChanged) {
                        this.table.props.onModelChanged(this.field, row);
                    }
                }
            });
            const element = textComp.render();
            return element;
        }
        else {
            let value = row[this.def.dataField];
            if (value !== undefined && value != null && typeof value == "number" && typeof this.decimals == "number") {
                return <span>{value.toLocaleString("de", { maximumFractionDigits: this.decimals, minimumFractionDigits: this.decimals })}</span>;
            }
            else {
                return <span>{value}</span>;
            }
        }
    }

    public compare(modelA: any, modelB: any, asc: boolean): number {
        let aValue = app.anyToFloat(modelA[this.field], 0);
        let bValue = app.anyToFloat(modelB[this.field], 0);

        if (asc) {
            return aValue - bValue;
        }
        else {
            return bValue - aValue;
        }
    }

    public getUniqueVisibleItems(table: MsoTable): Array<ListItem> {
        let result = new Array<ListItem>();
        let dict: { [id: string]: number } = {};
        let isNull: boolean = false;
        for (let model of this.getRowModelsForFilter(table)) {
            const text = model[this.field];
            if (!text)
                isNull = true;

            if ((text != null) && (typeof (text) == 'number')) {
                if (!(text in dict)) {
                    dict[text] = 1;
                }
            }
        }

        for (let text in dict) {
            result.push({ id: text, name: text });
        }

        result.sort((a: ListItem, b: ListItem): number => {
            return a.name.localeCompare(b.name);
        });

        if (isNull)
            result.unshift({ id: "null", name: `${Resources.Common.null}` });

        return result;
    }
}